import React, { createContext, useContext, useRef, useState } from "react"

const ModalContext = createContext()

export const ModalProvider = ({ children }) => {

    const [failModal, setFailModal] = useState({ isOpen: false, message: "", data: {} })
    const [loading, setLoading] = useState({ isOpen: false })
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({
        isOpen: false,
        message: "",
    })

    const confirmResolver = useRef(null)

    // 🔥 Public Functions
    const showFail = (message, data = {}) =>
        setFailModal({ isOpen: true, message, data })

    const hideFail = () =>
        setFailModal({ isOpen: false, message: "", data: {} })

    const showLoading = () =>
        setLoading({ isOpen: true })

    const hideLoading = () =>
        setLoading({ isOpen: false })

    const showSuccess = (data = {}) =>
        setSuccessModal({ isOpen: true, data })

    const hideSuccess = () =>
        setSuccessModal({ isOpen: false, data: {} })

    // 🔥 Promise-based confirmation
    const confirm = (message) => {
        setConfirmationModal({
            isOpen: true,
            message,
        })

        return new Promise((resolve) => {
            confirmResolver.current = resolve
        })
    }

    const handleConfirm = () => {
        setConfirmationModal({ isOpen: false, message: "" })
        confirmResolver.current?.(true)
    }

    const handleCancel = () => {
        setConfirmationModal({ isOpen: false, message: "" })
        confirmResolver.current?.(false)
    }

    return (
        <ModalContext.Provider
            value={{
                showFail,
                hideFail,
                showLoading,
                hideLoading,
                showSuccess,
                hideSuccess,
                confirm,
                handleConfirm,
                handleCancel,
                failModal,
                loading,
                successModal,
                confirmationModal
            }}
        >
            {children}
        </ModalContext.Provider>
    )
}

export const useModal = () => useContext(ModalContext)